import React from 'react';
import { Breadcrumb, Typography, Space } from 'antd';
import { HomeOutlined, DollarOutlined } from '@ant-design/icons';
import PaymentMilestones from '../components/Orders/PaymentMilestones';

const { Title } = Typography;

const PaymentMilestonesPage = () => {
    return (
        <div>
            <Breadcrumb
                style={{ marginBottom: '16px' }}
                items={[
                    {
                        href: '/',
                        title: <HomeOutlined />,
                    },
                    {
                        title: (
                            <Space>
                                <DollarOutlined />
                                <span>Payment Milestones</span>
                            </Space>
                        ),
                    },
                ]}
            />

            <div style={{ marginBottom: '24px' }}>
                <Title level={2}>Payment Milestones</Title>
                <Typography.Text type="secondary">
                    Manage partial payments and track remaining balances for customer orders.
                </Typography.Text>
            </div>

            <PaymentMilestones />
        </div>
    );
};

export default PaymentMilestonesPage;
